import { pickBy, isNil } from "lodash"

/**
 * Request object for fetching filtered recipients based on advanced filtering criteria
 * 
 * @description Fetches recipients (parents, learners, or staff) that match the
 * specified filter criteria from d6+ Advanced Filtering.
 * 
 * Uses legacy d6+ parameter names:
 * - status: '1' (current), '2' (left), '7' (waitlist)
 * - current_on: Date when learners were current (for status=2)
 * - wait_year: Waitlist year (for status=7)
 * - for: Filter by option value
 * - filter: Array of selected filter IDs
 * - which: Parent type (parents only)
 * - gender: Gender filter
 * 
 * Each entity type has its own endpoint:
 * - POST /portal/v1/advanced-filtering/parents/recipients
 * - POST /portal/v1/advanced-filtering/learners/recipients
 * - POST /portal/v1/advanced-filtering/staff/recipients
 */
class PostAdvancedFilteringRecipientsRequest {

    constructor({ 
        communityId,
        entityType,        // 'parents' | 'learners' | 'staff' (used for endpoint selection)
        status,            // '1' (current), '2' (left), '7' (waitlist)
        currentOn,         // Date string for historical learner lookup (YYYY-MM-DD)
        waitYear,          // Waitlist year
        for: forValue,     // Filter by option value ('0' = all)
        filter,            // Array of selected filter IDs
        which,             // Parent type (parents only): '1' (all), '0' (preferred), '2' (male), '3' (female)
        gender,            // '0' (all), '1' (boys/female), '2' (girls/male)
        search,            // Search query
        page,              // Pagination page
        perPage,           // Items per page
    }) {
        this.communityId = communityId
        this.entityType = entityType
        this.status = status
        this.currentOn = currentOn
        this.waitYear = waitYear
        this.for = forValue
        this.filter = filter
        this.which = which
        this.gender = gender
        this.search = search
        this.page = page
        this.perPage = perPage
    }

    getPayload = () => {
        
        const payload = {
            "community_id": this.communityId,
            "status": this.status,
            "current_on": this.currentOn,
            "wait_year": this.waitYear,
            "for": this.for,
            "filter": this.filter,
            "which": this.which,
            "gender": this.gender,
            "search": this.search,
            "page": this.page,
            "per_page": this.perPage?.value || this.perPage,
        }

        // Remove null/undefined values but keep empty arrays
        return pickBy(payload, (value) => !isNil(value))
    }
    
}

export default PostAdvancedFilteringRecipientsRequest
